import * as React from "react";
import Collapsible from "react-collapsible";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleDown, faChevronCircleUp } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { applySettingFilters, clientSettingsData, dateFormatter, errorToastr, getClientSettingsData, history, initialDataState, localDateTime, successToastr, warningToastr } from "../../../../HelperMethods";
import BreadCrumbs from "../../../Shared/BreadCrumbs/BreadCrumbs";
import ExtensionInformation from "./ExtensionInformation";
import BillRateAndExpenses from "../../../Candidates/BillRateAndExpenses/BillRateAndExpenses";
import auth from "../../../Auth";
import ProviderContracts from "../ProviderContracts/ProviderContracts";
import { APPROVE_ASSIGNMENT_EXTENSION_MSG, APPROVE_EXTENSION_CONTRACT_VALIDATION_MSG, ASSIGNMENT_EXTENSION_REQUEST_SUCCESS_MSG, ASSIGNMENT_EXTENSION_UPDATED_SUCCESS_MSG, DUPLICATE_CONTRACT_WARNING_MSG, EXTEND_ASSIGNMENT_MSG, EXTENSION_BILL_RATE_LIMIT_EXCEEDS, EXTENSION_CONTRACT_WARNING_MSG, EXTENSION_TIME_CONTRACT_VALIDATION_MSG, INFO_MSG_FOR_BILLRATES_DATE_UPDATE, PENDINGAPPROVAL_EXTENSION_END_DATE_ERROR, REJECT_ASSIGNMENT_EXTENSION_MSG, OVERRIDE_BILL_RATE_NOT_ALLOWED } from "../../../Shared/AppMessages";
import FormActions from "../../../Shared/Workflow/FormActions";
import { JOB_DETAIL } from "../../../Shared/ApiUrls";
import ConfirmationModal from "../../../Shared/ConfirmationModal";
import { AlertBoxTitle, BillRateStatus, CandidateWorkflow, DocStatus, DocType, ExtensionActionStatuses, ExtensionStatuses, RateLockdownBillRateCheck, SETTINGS, SettingCategory, WfStatus } from "../../../Shared/AppConstants";
import AlertBox from "../../../Shared/AlertBox";
import RejectModal from "../../../Shared/RejectModal";
import ConfirmationLetter from "../../../Candidates/MakeAnOffer/OfferInformation/ConfirmationLetter";
import SkeletonWidget from "../../../Shared/Skeleton";
import { candTriggerName } from "../../../ReusableComponents";
import CandidateInformation from "../../../Shared/CandidateInformation/CandidateInformation";
import { toODataString } from "@progress/kendo-data-query";
import { AppPermissions } from "../../../Shared/Constants/AppPermissions";
import CommonDataService from "../../../Shared/Services/CommonDataService";

export interface CreateAssignmentExtensionProps {
    props: any;
    match: any;
    onCloseModal: any;
    onOpenModal: any;
}

export interface CreateAssignmentExtensionState {
    candSubmissionId: string;
    candSubExtId?: string;
    clientId: string;
    reqNumber: string;
    candSubDetails: any;
    jobStartDate?: any;
    jobEndDate?: any;
    positionId?: any;
    jobPositionId?: string;
    locationId?: any;
    divisionId?: string;
    candidateId?: string;
    candidateName?: string;
    vendor?: any;
    status?: string;
    statusIntId?: number;
    extStartDate?: any;
    extEndDate?: any;
    specialTerms?: any;
    extStatus?: string;
    extensionStatus?: string;
    submitted: boolean;
    toggleAll: boolean;
    isPrivate?: boolean;
    showLoader?: boolean;
    isDirty?: boolean;
    toggleFirst: boolean;
    toggleSecond: boolean;
    showRequestForExtensionModal?: boolean;
    showExtendOfferModal?: boolean;
    showRejectModal?: boolean;
    isView: boolean;
    openAlert?: boolean;
    showAlert: boolean;
    location?: string;
    position?: string;
    isPilot?: boolean;
    isRateLockdown?: any;
    toggleCandidate: boolean;
    submittedVendorId?: string;
    isPayRateEnabled?: boolean;
    effectiveDate?: boolean;
    isCalculateBillRateEnable?: boolean;
    vendorTierProviderRate?: any;
    isVendorTier?: boolean;
    markupPer?: any;
    isExpenseRateCard: boolean;
    maxExtEndDate?: any;
    previousExtEndDate?: any;
    isVendorRole?: boolean;
    isDocExecuted: boolean;
    reqCreatedDate?: any;
    isConfirmationEnableInWf?: boolean;
}

class CreateAssignmentExtension extends React.Component<CreateAssignmentExtensionProps, CreateAssignmentExtensionState> {
    public extensionChild: any;
    public billRateChild: any;
    public extensionContracts: any;
    public confirmationLetter;
    public alertTitle;
    statusId: any;
    eventName: any;
    actionId: any;
    action: any;
    existingExtStartDate: any;
    existingExtEndDate: any;
    candDocumentsId: any;
    jobEndDate: any;
    alertMessage: any;
    extData: any;
    constructor(props: CreateAssignmentExtensionProps) {
        super(props);
        this.state = {
            candSubmissionId: "",
            reqNumber: "",
            clientId: auth.getClient(),
            candSubDetails: {},
            jobStartDate: null,
            jobEndDate: null,
            extStartDate: null,
            extEndDate: null,
            extStatus: WfStatus.ASSIGNMENTSTARTED,
            submitted: false,
            toggleAll: false,
            isDirty: false,
            toggleFirst: true,
            toggleSecond: true,
            isView: false,
            showLoader: true,
            showAlert: false,
            toggleCandidate: true,
            isPayRateEnabled: false,
            isVendorTier: false,
            markupPer: 0,
            isExpenseRateCard: false,
            maxExtEndDate: null,
            isVendorRole: auth.hasPermissionV2(AppPermissions.ALLOW_OVERRIDE),
            isDocExecuted: false
        };

        this.state = this.state;
    }

    componentDidMount() {
        const { subId } = this.props.match.params;
        const { candSubExtId } = this.props.match.params;
        const isView = window.location.href.search('edit') === -1 ? true : false;
        this.setState({ candSubmissionId: subId, candSubExtId: candSubExtId, isView: isView });
        // if (candSubExtId) {
        //     this.getClientSettings(this.state.clientId);
        //     this.getExtensionDetails(subId, candSubExtId)
        // } else {
        //     this.getExtensions(subId);
        //     this.getClientSettings(this.state.clientId);
        //     this.getCandSubPresentationInfo(subId);
        // }

        if(subId){
            this.getExtensions(subId, candSubExtId);
            this.getClientSettings(this.state.clientId);
        }

        if (subId && candSubExtId == null){
            this.getCandSubPresentationInfo(subId);
        }
    }

    getExtensions = (candSubmissionId, candSubExtId) => {
        // let queryStr = `$filter=status in ('${ExtensionStatuses.APPROVED}','${ExtensionStatuses.COMPLETED}')`;

        this.setState({ showLoader: true });
        axios.get(`api/candidates/${candSubmissionId}/assignmentextensions`)
            .then((res: any) => {
                if (res.data.length > 0) {
                    let filteredData = res.data.filter(item => item.status === ExtensionStatuses.APPROVED || item.status === ExtensionStatuses.COMPLETED || item.status === ExtensionStatuses.CLOSED)
                    if( filteredData.length > 0){
                    this.existingExtStartDate = filteredData[0].extEndDate != null && filteredData[0].extEndDate != undefined && filteredData[0].extEndDate != ""
                        ? new Date(new Date(filteredData[0].extEndDate).setDate(new Date(filteredData[0].extEndDate).getDate() + 1))
                        : new Date(new Date(filteredData[0].extEndDate).setDate(new Date(filteredData[0].extEndDate).getDate() + 1));
                    this.jobEndDate = filteredData[0].extEndDate != null && filteredData[0].extEndDate != undefined && filteredData[0].extEndDate != ""
                        ? (filteredData[0].extEndDate)
                        : filteredData[0].extEndDate;
                    }
                    this.extData = res.data
                }
                if (candSubExtId) {
                    this.getExtensionDetails(candSubmissionId, candSubExtId, this.extData)
                } else {
                    this.getCandidateSubmissionDetails(candSubmissionId, this.existingExtStartDate, this.jobEndDate);
                }
            });
    };

    // getExtensions = (candSubmissionId, candSubExtId) => {

    //     this.setState({ showLoader: true });
    //     axios.get(`api/candidates/${candSubmissionId}/assignmentextensions?`)
    //         .then((res: any) => {
    //             if (res.data.length > 0) {
    //             let index = res.data?.findIndex((data) => data.candSubExtId === candSubExtId)
    //             let data = null
    //             if (index >= 0) {
    //                 data = res.data?.slice(index + 1)?.find((data) => data.status === ExtensionStatuses.APPROVED || data.status === ExtensionStatuses.COMPLETED)
    //                 // if(data){
    //                 //     this.existingExtStartDate = new Date(new Date(data.extEndDate).setDate(new Date(data.extEndDate).getDate() + 1))
    //                 //     this.jobEndDate = data.extEndDate
    //                 // }
    //             }
    //             else {
    //                 data = res.data?.find((data) => data.status === ExtensionStatuses.APPROVED || data.status === ExtensionStatuses.COMPLETED)
    //                 if(data){
    //                     this.existingExtStartDate = new Date(new Date(data.extEndDate).setDate(new Date(data.extEndDate).getDate() + 1))
    //                     this.jobEndDate = data.extEndDate
    //                 }
    //             }
                
    //             let lastExtensionEndDate = data ? data.extEndDate : null
    //             this.setState({ previousExtEndDate: lastExtensionEndDate })
    //             this.jobEndDate = lastExtensionEndDate
    //         }
    //         if (candSubExtId) {
    //             this.getExtensionDetails(candSubmissionId, candSubExtId, this.jobEndDate)
    //         } else {
    //             this.getCandidateSubmissionDetails(candSubmissionId, this.existingExtStartDate, this.jobEndDate);
    //         }
    //         });
    // };

    async getCandidateSubmissionDetails(candSubmissionId, existingExtStartDate?, jobEndDate?) {
        this.setState({ showLoader: true });
        await axios
            .get(`api/candidates/workflow/${candSubmissionId}`)
            .then((res:any) => {
                this.setState({
                    candSubDetails: res.data,
                    reqNumber: res.data.reqNumber,
                    locationId: res.data.locationId,
                    positionId: res.data.positionId,
                    jobPositionId: res.data.jobPositionId,
                    divisionId: res.data.divisionId,
                    status: res.data.status,
                    statusIntId: res.data.statusIntId,
                    candidateId: res.data.candidateId,
                    candidateName: res.data.candidateName,
                    vendor: res.data.vendor,
                    isPilot: res.data.isPilot,
                    reqCreatedDate: res.data.reqCreatedDate,
                    location: res.data.location,
                    position: res.data.position,
                    submittedVendorId: res.data.submittedVendorId,
                    jobStartDate:
                        res.data.startDate != null &&
                            res.data.startDate != undefined &&
                            res.data.startDate != ""
                            ? (res.data.startDate)
                            : res.data.startDate,
                    jobEndDate:
                        jobEndDate != null && jobEndDate != undefined && jobEndDate != ""
                            ? jobEndDate
                            : res.data.endDate != null &&
                                res.data.endDate != undefined &&
                                res.data.endDate != ""
                                ? (res.data.endDate)
                                : res.data.endDate,
                    extStartDate:
                        existingExtStartDate != null && existingExtStartDate != undefined && existingExtStartDate != ""
                            ? existingExtStartDate
                            : res.data.endDate != null &&
                                res.data.endDate != undefined &&
                                res.data.endDate != ""
                                ? new Date(new Date(res.data.endDate).setDate(new Date(res.data.endDate).getDate() + 1))
                                : new Date(new Date(res.data.endDate).setDate(new Date(res.data.endDate).getDate() + 1)),
                    showLoader: false
                }, () => {
                    if (document.getElementsByName('extStartDate')) {
                        document.getElementsByName('extStartDate')[0]['disabled'] = true;
                        document.getElementsByName('extEndDate')[0]['disabled'] = true;
                    };
                    this.getExecutedDoc(this.state.candSubmissionId);
                    this.getAssociatedVendors(this.state.clientId, this.state.submittedVendorId);
                    this.getClientSetting(this.state.clientId, this.state.divisionId, this.state.locationId, this.state.submittedVendorId);
                    this.getLetterAndForecastStatusInWf(res.data.jobWfTypeId)
                });
            });
    }

    getLetterAndForecastStatusInWf = (jobWfTypeId) => {
        if (jobWfTypeId != undefined){
          CommonDataService.getLetterOrForecastStatusInWf(jobWfTypeId)
              .then((data:any) => this.setState({
                isConfirmationEnableInWf: data.isConfirmLetter
              })
          );
        }
    }

    getCandSubPresentationInfo = (candSubmissionId: string) => {
        this.setState({ showLoader: true });
        axios.get(`api/candidates/workflow/${candSubmissionId}/presentationinfo`)
            .then((result:any) => {
                if (result != null && result.data != "") {
                    this.setState({
                        specialTerms: result.data.specialTerms
                    });
                }
            });
    };

    getExtensionDetails = (candSubmissionId, candSubExtId, extData) => {
        let index = extData?.findIndex((data)=>data.candSubExtId === candSubExtId)
        let data = null
        if(index >=0){
            data = extData?.slice(index+1)?.find((data)=> data.status === ExtensionStatuses.APPROVED || data.status === ExtensionStatuses.COMPLETED || data.status === ExtensionStatuses.CLOSED)
        }
        let lastExtensionEndDate = data ? data.extEndDate : null
        this.setState({previousExtEndDate:lastExtensionEndDate})
        this.jobEndDate= lastExtensionEndDate

        let queryStr = `$filter=candSubExtId eq ${candSubExtId}`;
        this.setState({ showLoader: true });
        axios.get(`api/candidates/${candSubmissionId}/assignmentextensions?${queryStr}`)
            .then((res:any) => {
                console.log("show...",res.data)
                this.setState({
                    extEndDate:
                        res.data[0].extEndDate != null &&
                            res.data[0].extEndDate != undefined &&
                            res.data[0].extEndDate != ""
                            ? (res.data[0].extEndDate)
                            : res.data[0].extEndDate,
                    extStatus: res.data[0].status,
                    extensionStatus: res.data[0].status,
                    specialTerms: res.data[0].specialTerms,
                    maxExtEndDate:
                        res.data[0].extEndDate != null &&
                            res.data[0].extEndDate != undefined &&
                            res.data[0].extEndDate != ""
                            ? (res.data[0].extEndDate)
                            : res.data[0].extEndDate,
                });
                this.existingExtStartDate = res.data[0].extStartDate != null && res.data[0].extStartDate != undefined && res.data[0].extStartDate != ""
                    ? (res.data[0].extStartDate)
                    : res.data[0].extStartDate;
           
                if (res.data[0].status !== ExtensionStatuses.PENDINGAPPROVAL) {
                    this.setState({ specialTerms: null });
                    this.getCandSubPresentationInfo(candSubmissionId);
                }
                this.getCandidateSubmissionDetails(candSubmissionId, this.existingExtStartDate, this.jobEndDate);
            });
    };

    handleChange = (e) => {
        let change = { isDirty: true };
        change[e.target.name] = e.target.value;
        this.setState(change);
    };

    saveExtension(props) {
        this.setState({ submitted: true, showRequestForExtensionModal: false })
        let isValid = this.checkValidations();
        if (isValid) {
            this.setState({ submitted: true })
            let data = {
                candSubmissionId: this.state.candSubmissionId,
                extStartDate: localDateTime(this.state.extStartDate),
                extEndDate: localDateTime(this.state.extEndDate),
                specialTerms: this.state.specialTerms,
                extensionContracts: this.extensionContracts.getContractData().data,
                statusId: this.statusId,
                eventName: this.eventName,
                actionId: this.actionId,
                isVendorRole: this.state.isVendorRole,
                ...props
            };

            if (this.state.candSubmissionId) {
                const { candSubmissionId } = this.state;
                if ((this.state.extStartDate != undefined && this.state.extStartDate != null) && (this.state.extEndDate != undefined && this.state.extEndDate != null)) {
                    axios.post(`api/candidates/assignmentextendrequest`, JSON.stringify(data)).then((res) => {
                        if (res.data && !res.data.isSuccess && res.data.statusMessage == RateLockdownBillRateCheck.OVERRIDE_BILL_RATE_MESSAGE) {
                            this.alertMessage = OVERRIDE_BILL_RATE_NOT_ALLOWED(res.data.responseCode);
                            this.alertTitle = AlertBoxTitle.BILL_RATE_ALERT;
                            this.setState({ openAlert: true });
                            return false;
                        }
                        else if (res.data && !res.data.isSuccess && res.data.statusMessage == RateLockdownBillRateCheck.BILL_RATE_LIMIT_EXCEED) {
                            this.alertMessage = EXTENSION_BILL_RATE_LIMIT_EXCEEDS(this.state.location, this.state.position, res.data.responseCode);
                            this.alertTitle = AlertBoxTitle.BILL_RATE_ALERT;
                            this.setState({ openAlert: true });
                            return false;
                        }else{
                            successToastr(ASSIGNMENT_EXTENSION_REQUEST_SUCCESS_MSG);
                            history.push(`${JOB_DETAIL}${candSubmissionId}`);
                        }
                    });
                }
            }
        }
    }

    updateExtension(candSubExtId, props?) {
        if (this.state.extStatus === ExtensionStatuses.PENDINGAPPROVAL
            && this.state.extEndDate < new Date(new Date(new Date()).setDate(new Date(new Date()).getDate() - 1))) {
            this.setState({ showExtendOfferModal: false });
            errorToastr(PENDINGAPPROVAL_EXTENSION_END_DATE_ERROR);
            return;
        }
        this.setState({ submitted: true, showExtendOfferModal: false, showRejectModal: false, showLoader: true })
        let data = {
            candSubmissionId: this.state.candSubmissionId,
            candSubExtId: candSubExtId,
            extStartDate: localDateTime(this.state.extStartDate),
            extEndDate: localDateTime(this.state.extEndDate),
            specialTerms: this.state.specialTerms,
            statusId: this.statusId,
            eventName: this.eventName,
            actionId: this.actionId,
            action: this.action,
            ...props
        };

        if (this.state.candSubmissionId && candSubExtId) {
            const { candSubmissionId, isConfirmationEnableInWf } = this.state;
            if (this.action == ExtensionActionStatuses.EXTENDOFFER || this.action == ExtensionActionStatuses.REJECT) {
                if ((this.state.extStartDate != undefined && this.state.extStartDate != null) && (this.state.extEndDate != undefined && this.state.extEndDate != null)) {
                    axios.patch(`api/candidates/assignmentextension/${candSubExtId}`, JSON.stringify(data)).then((res) => {
                        if ((this.action == ExtensionActionStatuses.EXTENDOFFER || (this.action == ExtensionActionStatuses.SAVE && this.state.extStatus === ExtensionStatuses.APPROVED)) && isConfirmationEnableInWf) {
                            this.getDocPortfolio(this.state.candSubmissionId)
                            successToastr(ASSIGNMENT_EXTENSION_UPDATED_SUCCESS_MSG);
                            this.setState({ showLoader: false })
                        } else {
                            successToastr(ASSIGNMENT_EXTENSION_UPDATED_SUCCESS_MSG);
                            history.push(`${JOB_DETAIL}${candSubmissionId}`);
                        }
                    }).catch(error => {
                        this.setState({ showLoader: false });
                    });
                }
            }
            else {
                if ((this.state.extStartDate != undefined && this.state.extStartDate != null) && (this.state.extEndDate != undefined && this.state.extEndDate != null)) {
                    axios.post(`api/candidates/assignmentextension/${candSubExtId}`, JSON.stringify(data)).then((res) => {
                        successToastr(ASSIGNMENT_EXTENSION_UPDATED_SUCCESS_MSG);
                        history.push(`${JOB_DETAIL}${candSubmissionId}`);
                    }).catch(error => {
                        this.setState({ showLoader: false });
                    });
                }
            }
        }
    }

    getDocPortfolio = (candSubmissionId) => {
        var submission = candSubmissionId;
        var queryParams = '';
        if (submission != "" && submission != null && submission != undefined) {
            queryParams = "?candSubmissionId=" + candSubmissionId + "&$filter=docType eq 'Confirmation Letter' and status eq 'Pending Signature'"
        }
        axios.get(`/api/candidates/${this.state.candidateId}/documents` + queryParams).then((res: any) => {
            if (res) {
                this.candDocumentsId = res.data[0].candDocumentsId
                this.confirmationLetter.getDocumentPortfolio(this.candDocumentsId)
            }
        });
    }

    checkValidations() {
        let extensionContracts = this.extensionContracts.getContractData();
        if (extensionContracts.data.length <= 0) {
            warningToastr(EXTENSION_TIME_CONTRACT_VALIDATION_MSG);
            return false;
        }

        if (extensionContracts.hasError) {
            warningToastr(EXTENSION_CONTRACT_WARNING_MSG);
            return false;
        }

        if (extensionContracts.hasDuplicateRecords) {
            warningToastr(DUPLICATE_CONTRACT_WARNING_MSG);
            return false;
        }

        if (extensionContracts.hasNoTimeCategoryData) {
            warningToastr(EXTENSION_TIME_CONTRACT_VALIDATION_MSG);
            return false;
        }

        if (this.state.extEndDate == undefined || this.state.extEndDate == null) {
            this.setState({ submitted: true });
            return false;
        }

        return true;
    }

    getProviderContractCount = async () => {
        let pendingContractCount;

        let queryParams = `candSubId eq ${this.state.candSubmissionId} and candSubExtId eq ${this.state.candSubExtId}`;

        await axios.get(`api/candidates/billrate?$filter=${queryParams}`).then((res:any) => {
            pendingContractCount = res.data.filter((i) => i.status == BillRateStatus.PENDINGAPPROVAL).length;
        });

        return pendingContractCount;
    };

    handleActionClick = async (action, nextStateId?, eventName?, actionId?) => {
        this.statusId = nextStateId;
        this.eventName = eventName;
        this.actionId = actionId;
        this.action = action;

        if (action == ExtensionActionStatuses.REQUESTFOREXTENSION) {
            let isValid = this.checkValidations();
            if (!isValid) {
                return false;
            }
        }

        if (action == ExtensionActionStatuses.SAVE) {
            this.updateExtension(this.state.candSubExtId);
        }

        if (action == ExtensionActionStatuses.EXTENDOFFER) {
            let pendingContractCount = await this.getProviderContractCount();
            if (pendingContractCount > 0) {
                this.alertMessage = APPROVE_EXTENSION_CONTRACT_VALIDATION_MSG;
                this.setState({ openAlert: true });
                return false;
            }
        }

        let change = {};
        let property = `show${action.replace(/ +/g, "")}Modal`;
        change[property] = true;
        this.setState(change);
    };

    handleConfirmationStatusAlert = (responseCode) => {
        if (responseCode == "CSU"){
            this.setState({showAlert: true});
        }
    }

    onCollapseOpen = () => {
        this.setState({
            toggleAll: true,
            toggleFirst: true,
            toggleSecond: true,
            toggleCandidate: true
        });
    };

    onCollapseClose = () => {
        this.setState({
            toggleAll: false,
            toggleFirst: false,
            toggleSecond: false,
            toggleCandidate: false
        });
    };

    getClientSettings = (clientId) => {
        getClientSettingsData(clientId).then((res) => {

            applySettingFilters(res, SettingCategory.CANDIDATE, SETTINGS.RATE_LOCKDOWN, (response) => {
                this.setState({ isRateLockdown: response });
            });
            applySettingFilters(res, SettingCategory.CANDIDATE, SETTINGS.EXPENSE_RATE_CARD, (response) => {
                this.setState({ isExpenseRateCard: response });
            });
        });
    };

    getClientSetting = (clientId, divisionId, locationId, vendorId) => {
        getClientSettingsData(clientId).then((res) => {

            applySettingFilters(res, SettingCategory.CANDIDATE, SETTINGS.CALCULATE_BILL_RATE, (response) => {
                this.setState({ isCalculateBillRateEnable: response });
            });

            applySettingFilters(res, SettingCategory.CANDIDATE, SETTINGS.CALCULATE_BILL_RATE, (response) => {
                if (response == true) {
                    applySettingFilters(res, SettingCategory.CANDIDATE, SETTINGS.PAY_RATE_EFFECTIVE_DATE, (res) => {
                        this.setState({ effectiveDate: res }, () => {
                            this.getEffectiveDates(this.state.candSubmissionId, this.state.effectiveDate);
                        });
                    });
                } else {
                    this.setState({ isCalculateBillRateEnable: response });
                }
            });

            applySettingFilters(res, SettingCategory.CANDIDATE, SETTINGS.ENABLE_PAY_RATE, (response) => {
                this.setState({ isPayRateEnabled: response });
            });

            applySettingFilters(res, SettingCategory.CANDIDATE, SETTINGS.VENDOR_TIER_PAY_RATE, (response) => {
                this.setState({ vendorTierProviderRate: response }, () => {
                    this.getVendorTiers(clientId, divisionId, locationId, vendorId, this.state.vendorTierProviderRate);
                });
            });
        });
    };
    
    getVendorTiers = (clientId, divisionId, locationId, vendorId, vendorTierProviderRate) => {
        if (vendorId != null) {
            axios.get(`api/vendor/vendortier?clientId=${clientId}&divisionId=${divisionId}&locationId=${locationId}&vendorId=${vendorId}&tiers=${vendorTierProviderRate}`).then((res:any) => {
                if (res.data.length > 0) {
                    this.setState({
                        isVendorTier: true
                    });
                }
            });
        }
    };

    getAssociatedVendors = (clientId, vendorId) => {
        let queryParams = `$filter=vendorId eq ${vendorId} and status eq 'Active'`;
        axios.get(`api/clients/${clientId}/vendor?${queryParams}`)
            .then((res: any) => {
                if (res.data.length > 0) {
                    this.setState({
                        markupPer: res.data[0].markupPer == null ? 0 : res.data[0].markupPer
                    });
                }
            });
    }

    getEffectiveDates = (candSubmissionId, effectiveDate) => {
        if (candSubmissionId != null && effectiveDate != null) {
            const queryParams = `entityId eq ${candSubmissionId} and (newStatus eq '${WfStatus.PENDINGVENDORPRESENTATION}' or newStatus eq '${WfStatus.READYFOROFFER}')`;
            axios.get(`api/workflow/history?$filter=${queryParams}`).then((res: any) => {
                if (res.data.length > 0) {
                    this.setState({
                        isCalculateBillRateEnable: dateFormatter(new Date(res.data[0].actionDate)) >= dateFormatter(new Date(effectiveDate)) ? true : false
                    });
                }
            });
        }else{
            this.setState({
                isCalculateBillRateEnable: false
            });
        }
    };

    hideButton = (isView) => {
        let buttons = ["Close", "Cancel"]
        if (isView) {
            buttons.push("Save")
        }
        return buttons;
    }

    generateLetter = (extEndDate) => {
        extEndDate = new Date(new Date(extEndDate).setDate(new Date(extEndDate).getDate()))
        return extEndDate.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)
    }

    getExecutedDoc = (candSubmissionId) => {
        var submission = candSubmissionId;
        var queryParams = '';
        if (submission != "" && submission != null && submission != undefined) {
            queryParams = "?candSubmissionId=" + candSubmissionId + "&$filter=docType eq 'Confirmation Letter' and (status eq 'Executed' or status eq 'Client Signed')"
        }
        axios.get(`/api/candidates/${this.state.candidateId}/documents` + queryParams).then((res: any) => {
            if (res) {
              let docExecuted = res.data?.filter(x => (x.status === DocStatus.EXECUTED || x.status === DocStatus.CLIENTSIGNED) && x.candidateId == this.state.candSubmissionId && x.docType == DocType.CONFIRMATIONLETTER);
              this.setState({ isDocExecuted:  docExecuted && docExecuted.length ? true : false })
            }
        });
      }

    render() {
        const {
            candSubmissionId,
            candSubExtId,
            candSubDetails,
            jobStartDate,
            jobEndDate,
            clientId,
            locationId,
            positionId,
            jobPositionId,
            divisionId,
            status,
            statusIntId,
            extStartDate,
            extEndDate,
            extStatus,
            specialTerms,
            isView,
            toggleAll,
            toggleFirst,
            toggleSecond,
            submitted,
            candidateId,
            showLoader,
            extensionStatus,
            toggleCandidate,
            maxExtEndDate,
            previousExtEndDate
        } = this.state;

        const extensionInfo = {
            candSubmissionId,
            candSubExtId,
            jobStartDate,
            jobEndDate,
            status,
            statusIntId,
            extStartDate,
            extEndDate,
            extStatus,
            specialTerms,
            isView,
            submitted,
            showLoader,
            extensionStatus,
            maxExtEndDate,
            previousExtEndDate
        };

        const extendAssignmentTriggerName = (
            <span>
                Extension Information
            </span>
        );
        return (
            <div className="col-11 mx-auto pl-0 pr-0 mt-3  mt-md-0">
                <div className="col-12">
                    <div className="row pt-2 pb-2 accordianTitleClr mx-auto mb-3 mt-3">
                        <div className="col-10 fonFifteen paddingLeftandRight">
                            <div className="d-none d-md-block">
                                <BreadCrumbs globalData={{ candSubmissionId: candSubmissionId, candSubExtId: candSubExtId }}></BreadCrumbs>
                            </div>
                        </div>

                        <div className="col-2 text-right mt-sm-1 mt-md-0 txt-orderno text-underline paddingRight d-flex align-items-center justify-content-end ">
                            {(toggleCandidate && toggleFirst && toggleSecond) ||
                                toggleAll ? (
                                <FontAwesomeIcon
                                    className="ml-2 mt-1 text-primary collapseExpandIcon globalExpandCursor"
                                    icon={faChevronCircleUp}
                                    onClick={
                                        toggleAll ? this.onCollapseClose : this.onCollapseOpen
                                    }
                                ></FontAwesomeIcon>
                            ) : (
                                <FontAwesomeIcon
                                    className="ml-2 mt-1 text-primary collapseExpandIcon globalExpandCursor"
                                    icon={faChevronCircleDown}
                                    onClick={
                                        toggleAll ? this.onCollapseClose : this.onCollapseOpen
                                    }
                                ></FontAwesomeIcon>
                            )}
                        </div>
                    </div>
                </div>

                <div className="col-12">
                    <Collapsible
                        trigger={candTriggerName(
                            "Candidate Information",
                            this.state.extensionStatus ? this.state.extensionStatus : "Draft"
                        )}
                        open={toggleCandidate}
                        onTriggerOpening={() => this.setState({ toggleCandidate: true })}
                        onTriggerClosing={() => this.setState({ toggleCandidate: false })}
                    >
                        {showLoader && <SkeletonWidget />}
                        {!showLoader && candSubDetails && candidateId && (
                            <CandidateInformation
                                candidateId={candidateId}
                                location={candSubDetails.location}
                                submissionData={candSubDetails}
                                jobDetailPage={true}
                                getDocPortfolio={this.getExecutedDoc}
                            />
                        )}
                    </Collapsible>
                    {showLoader && <SkeletonWidget />}
                    {!showLoader && (
                        <Collapsible
                            trigger={extendAssignmentTriggerName}
                            open={toggleFirst}
                            accordionPosition="1"
                            onTriggerOpening={() => this.setState({ toggleFirst: true })}
                            onTriggerClosing={() => this.setState({ toggleFirst: false })}
                        >
                            <ExtensionInformation
                                ref={(instance) => {
                                    this.extensionChild = instance;
                                }}
                                data={extensionInfo}
                                handleChange={this.handleChange}
                            />
                        </Collapsible>
                    )}
                    {!showLoader &&
                        candSubmissionId &&
                        candSubDetails &&
                        clientId &&
                        locationId &&
                        positionId &&
                        jobPositionId && (
                            <div>
                                <Collapsible
                                    trigger="Bill Rates and Expenses"
                                    open={toggleSecond}
                                    onTriggerOpening={() => this.setState({ toggleSecond: true })}
                                    onTriggerClosing={() => this.setState({ toggleSecond: false })}
                                >
                                    {(this.state.candSubExtId == null || this.state.candSubExtId == undefined) && this.state.candSubmissionId ? (
                                        <ProviderContracts
                                            ref={(instance) => {
                                                this.extensionContracts = instance;
                                            }}
                                            candSubmissionId={candSubmissionId}
                                            canEdit={true}
                                            clientId={clientId}
                                            positionId={jobPositionId}
                                            locationId={locationId}
                                            divisionId={divisionId}
                                            isPayRateEnabled={this.state.isPayRateEnabled}
                                            isCalculateBillRateEnable={this.state.isCalculateBillRateEnable}
                                            vendorTierProviderRate={this.state.vendorTierProviderRate}
                                            isVendorTier={this.state.isVendorTier}
                                            markupPer={this.state.markupPer}
                                            key="Contracts"
                                            isExpenseRateCard={this.state.isExpenseRateCard}
                                        />
                                    ) :
                                        <BillRateAndExpenses
                                            ref={(instance) => {
                                                this.billRateChild = instance;
                                            }}
                                            candSubmissionId={candSubmissionId}
                                            candSubExtId={candSubExtId}
                                            candidateName={this.state.candidateName}
                                            positionId={jobPositionId}
                                            locationId={locationId}
                                            divisionId={divisionId}
                                            candidateSubStatus={status}
                                            handleDisable={() => { }}
                                            handleEnable={() => { }}
                                            candidateSubStatusIntId={statusIntId}
                                            AssignmentStartDate={extStartDate}
                                            AssignmentEndDate={extEndDate}
                                            handleAlert={this.handleConfirmationStatusAlert}
                                            isRateLockdown={this.state.isRateLockdown}
                                            isPilot={this.state.isPilot}
                                            location={this.state.location}
                                            position={this.state.position}
                                            vendorId={this.state.submittedVendorId}
                                            isDocExecuted={this.state.isDocExecuted && this.state.extensionStatus !== ExtensionStatuses.PENDINGAPPROVAL}
                                            reqCreatedDate={this.state.reqCreatedDate}
                                            
                                        />
                                    }
                                </Collapsible>
                            </div>
                        )}
                </div>
                {!showLoader && this.state.extStatus && this.state.candSubmissionId &&(
                    <FormActions
                        wfCode={CandidateWorkflow.ASSIGNMENTEXTENSION}
                        currentState={this.state.extStatus}
                        handleClick={this.handleActionClick}
                        handleClose={() => history.goBack()}
                        hideBtn={this.hideButton(isView)}
                    />
                )}
                {this.state.showRequestForExtensionModal && this.actionId && (
                    <RejectModal
                        action={this.action}
                        actionId={this.actionId}
                        message={EXTEND_ASSIGNMENT_MSG()}
                        showModal={this.state.showRequestForExtensionModal}
                        handleYes={(data) => this.saveExtension(data)}
                        handleNo={() => {
                            this.setState({ showRequestForExtensionModal: false });
                        }}
                        isRequest={true}
                    />
                )}
                {this.state.showExtendOfferModal && this.actionId && (
                    <ConfirmationModal
                        message={APPROVE_ASSIGNMENT_EXTENSION_MSG()}
                        showModal={this.state.showExtendOfferModal}
                        handleYes={(e) => this.updateExtension(this.state.candSubExtId)}
                        handleNo={() => {
                            this.setState({ showExtendOfferModal: false });
                        }}
                    />
                )}
                {this.state.showRejectModal && this.actionId && (
                    <RejectModal
                        action={this.action}
                        actionId={this.actionId}
                        message={REJECT_ASSIGNMENT_EXTENSION_MSG()}
                        showModal={this.state.showRejectModal}
                        handleYes={(data) => this.updateExtension(this.state.candSubExtId, data)}
                        handleNo={() => {
                            this.setState({ showRejectModal: false });
                        }}
                    />
                )}
                {this.state.openAlert && (
                    <AlertBox
                        handleNo={() => {
                            this.setState({ openAlert: false });
                        }}
                        message={this.alertMessage}
                        showModal={this.state.openAlert}
                        title={this.alertTitle ? this.alertTitle : null}
                    ></AlertBox>
                )}
                {this.state.showAlert && (
                    <AlertBox
                        handleNo={() => {
                            this.setState({ showAlert: false });
                        }}
                        message={INFO_MSG_FOR_BILLRATES_DATE_UPDATE()}
                        showModal={this.state.showAlert}
                    ></AlertBox>
                )}
                <ConfirmationLetter
                    ref={(instance) => {
                        this.confirmationLetter = instance;
                    }}
                    candSubmissionId={this.state.candSubmissionId}
                    candidateId={this.state.candidateId}
                    vendor={this.state.vendor}
                    updateCandWf={false}
                    reqNumber={this.state.reqNumber}
                    jobDetailPage={true}
                    redirectTo={(`${JOB_DETAIL}${this.state.candSubmissionId}`)}
                    isRedirectTo={true}
                />
            </div>
        );
    }

}

export default CreateAssignmentExtension;